/**
 * ASSIST-01 item 7 — a guest taps "Register interest", signs in, and comes
 * back to the same listing, where the registration completes once.
 *
 * The carrier is the existing `redirect_after_auth` key (lib/authReturn.ts),
 * pointing at the listing with `?assist=join` (brief R18.5). The parameter
 * only says "this visit came back from the join button": the card registers
 * when it sees it with a signed-in viewer, through the idempotent
 * `register_assist_interest`, and removes it from the address bar first so a
 * second card on the page (mobile and desktop both mount) or a reload cannot
 * act on it again.
 *
 * Imports nothing, so `tsx` tests can load it directly.
 */

export const ASSIST_RETURN_PARAM = 'assist';
export const ASSIST_JOIN_VALUE = 'join';
export const ASSIST_JOIN_SEARCH = `?${ASSIST_RETURN_PARAM}=${ASSIST_JOIN_VALUE}`;

/** `/property/<slug>` → `/property/<slug>?assist=join` */
export function assistJoinReturnPath(pathname: string): string {
  return `${pathname}${ASSIST_JOIN_SEARCH}`;
}

export function hasAssistJoinParam(search: string): boolean {
  return new URLSearchParams(search).get(ASSIST_RETURN_PARAM) === ASSIST_JOIN_VALUE;
}

/** The same search string without the Assist parameter ('' when nothing is left). */
export function withoutAssistParam(search: string): string {
  const params = new URLSearchParams(search);
  params.delete(ASSIST_RETURN_PARAM);
  const rest = params.toString();
  return rest ? `?${rest}` : '';
}
